import React, { useEffect, useMemo, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import Step1Content from './Steps/Step1';
import { queryFilterParams } from '../../../../../utils';
import PdfVerificationStep from './Steps/PdfVerificationStep';
import Step2Enrollment from './Steps/Step2Enrollment';
import Step3Enrollment from './Steps/Step3Enrollment';
import { getGuidanceSettingsFromStorage } from '../../../../../components/Pages/Home/SettingsModal/storage-utils';

export interface StepProps {
  handleNextStep: (skipOneStep?: boolean) => void;
}

export default function Statements() {
  const navigate = useNavigate();
  const [step, setStep] = useState<number>(1);
  const { showCaptcha, showPdfViewer } = getGuidanceSettingsFromStorage();
  const [searchParams, setSearchParams] = useSearchParams();

  useEffect(() => {
    const currentStep = Number(searchParams.get('step') || 1);

    setStep(currentStep);

    /** Check is steps already completed */
    const isEnrollmentCompleted = JSON.parse(sessionStorage.getItem('enrollment-completed') || '{}');

    if (isEnrollmentCompleted === true) {
      navigate('/guidance/financial-institution/application', { replace: true });
    }
  }, []);

  useEffect(() => {
    const newStep = Number(searchParams.get('step') || 1);

    setStep(newStep);
  }, [searchParams.get('step')]);

  const handleNextStep = (skipNextStep = false) => {
    const addingAmount = skipNextStep ? 2 : 1;

    setStep(prevState => prevState + addingAmount);
    setSearchParams(
      queryFilterParams({
        step: ((Number(searchParams.get('step')) || 1) + addingAmount).toString(),
      }),
    );
  };

  const steps: { step: number; heading: string; content: React.ReactNode }[] = [
    {
      step: 1,
      heading: 'Additional Services / Statements',
      content: <Step1Content handleNextStep={handleNextStep} />,
    },
    {
      step: 2,
      heading: 'Additional Services / Statements',
      content: <PdfVerificationStep handleNextStep={handleNextStep} />,
    },
    {
      step: 3,
      heading: 'Additional Services / Statements / Enrollment Step 2',
      content: <Step2Enrollment handleNextStep={handleNextStep} />,
    },

    {
      step: 4,
      heading: 'Additional Services / Statements / Enrollment Step 3',
      content: <Step3Enrollment handleNextStep={handleNextStep} />,
    },
  ];

  /** Filter disabled steps in settings */
  const filteredSteps = useMemo(
    () =>
      steps
        .filter(itemStep => (showPdfViewer === false ? itemStep.step !== 1 : true))
        .filter(itemStep => (showCaptcha === false ? itemStep.step !== 2 : true)),
    [step],
  );

  const currentStep = useMemo(() => filteredSteps.find(item => item.step === step), [step]);

  useEffect(() => {
    /** When steps renders set first step from array in url, if still not set any */
    if (!searchParams.get('step')) {
      setSearchParams({ step: filteredSteps[0]?.step?.toString() }, { replace: true });
    }
  }, [filteredSteps]);

  return (
    <div>
      <div>
        <h1 className="text-lg sm:text-xl font-bold my-3">
          {currentStep?.heading || 'Additional Services / Statements'}
        </h1>
        <div className="bg-white p-4 sm:p-7 rounded-[10px] border child:mb-4 last:child:mb-0">
          {currentStep?.content}
        </div>
      </div>
    </div>
  );
}
